var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { RightOutlined } from '@ant-design/icons';
import Collapse from 'antd/es/collapse';
import { useState } from 'react';
import Div from '../../common/div';
import useGrantsRegion from '../single/hooks/use-grants-region';
import GrantCardBody from './grant-card-body';
import GrantCardHeader from './grant-card-header';
import GrantCardWrapper from './grant-card-wrapper';
import { StyledCollapse } from './styles';
const GrantCard = (_a) => {
    var { isSmall } = _a, props = __rest(_a, ["isSmall"]);
    const { featuredTags, parentPath = '/funding-explorer', type = isSmall ? 'preview' : 'detail', cardSize = 'large', filterform } = props, grant = __rest(props, ["featuredTags", "parentPath", "type", "cardSize", "filterform"]);
    const locationString = useGrantsRegion(grant);
    const [isExpanded, setIsExpanded] = useState(false);
    const handleExpandIconClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setIsExpanded(!isExpanded);
    };
    return (_jsx(GrantCardWrapper, Object.assign({}, props, { children: type === 'preview' ? (_jsx(StyledCollapse, { ghost: true, expandIconPosition: "end", activeKey: isExpanded ? ['1'] : [], onChange: () => { }, expandIcon: ({ isActive }) => (_jsx(Div, { onClick: handleExpandIconClick, children: _jsx(RightOutlined, { style: {
                        transform: isActive ? 'rotate(270deg)' : 'rotate(90deg)',
                        transition: 'transform 0.2s ease-in-out',
                    } }) })), children: _jsx(Collapse.Panel, { header: _jsx(GrantCardHeader, Object.assign({}, props, { parentPath: parentPath, locationString: locationString, featuredTags: featuredTags, type: type, cardSize: cardSize, isExpanded: isExpanded, filterform: filterform })), showArrow: true, children: _jsx(GrantCardBody, Object.assign({}, props, { locationString: locationString, type: type, cardSize: cardSize })) }, "1") })) : (_jsx(_Fragment, { children: _jsx(GrantCardHeader, Object.assign({}, props, { parentPath: parentPath, locationString: locationString, featuredTags: featuredTags, type: type, cardSize: cardSize })) })) })));
};
export default GrantCard;
